// Tarih biçimleri: gün.ay.yıl (Europe/Istanbul)
export function formatDate(value) {
  if (!value) return "-";
  try {
    let d;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, dd] = value.split("-");
      return `${dd}.${m}.${y}`;
    }
    d = new Date(value);
    if (isNaN(d.getTime())) return value;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}.${mm}.${d.getFullYear()}`;
  } catch {
    return value;
  }
}

// Geçerlilik durumu rozeti (90/60/30 gün eşikleri)
export function validityBadge(dateStr) {
  if (!dateStr) return { tone: "muted", text: "Tarih girilmedi" };
  const [y, m, d] = String(dateStr).split("-").map(Number);
  const target = new Date(y, (m || 1) - 1, d || 1);
  const diff = Math.ceil((target - new Date()) / 86400000);
  if (diff < 0) return { tone: "overdue", text: "Süresi geçti" };
  if (diff <= 30) return { tone: "pending", text: `${diff} gün` };
  if (diff <= 90) return { tone: "info", text: `${diff} gün` };
  return { tone: "active", text: `${diff} gün` };
}

// Eğitim durumu → rozet tonu (tek kaynak etiketleri)
export function trainingTone(s) {
  if (!s) return "muted";
  if (s === "Eğitimli") return "active";
  if (s.startsWith("Muaf")) return "info";
  if (s.includes("doldu")) return "overdue";
  if (s.includes("bekliyor")) return "pending";
  return "muted";
}

export function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${d.getFullYear()} ${hh}:${mi}`;
}
